import React from "react";
import {BrowserRouter as Router, useHistory} from "react-router-dom";

import 'materialize-css/dist/css/materialize.min.css'
import "materialize-css/dist/js/materialize.min.js";
import './App.scss';

import BackOffice from "./Container/BackOffice.react";
import OktaAuthProvider from "./Components/Auth/AuthProvider.react";

function App() {
  const history = useHistory();

  return (
    <Router>
       <OktaAuthProvider>
          <BackOffice />
       </OktaAuthProvider>
    </Router>
  );
}

export default App;
